// @flow
import types from "./types";
import type {LatLngLiteral} from "../../../Utils/MapUtils";

const updateMapInServicePolygon = (isInZone: boolean) => ({
    type: types.MAP_CENTER_IN_ZONE,
    payload: isInZone,
});

const mapFinishedLoading = () => ({
    type: types.MAP_LOADING_DONE,
});

const updateMapCenter = (center: LatLngLiteral) => ({
    type: types.MAP_CENTER_UPDATE,
    payload: center,
});

const panToLatlng = (latlng: LatLngLiteral) => ({
    type: types.MAP_FOCUS_LATLNG,
    payload: {latlng: latlng},
});

const focusMapBoundsFromArray = (latlngArray: Array<LatLngLiteral>) => ({
    type: types.MAP_FOCUS_BOUNDS,
    payload: latlngArray
});

export default {
    updateMapInServicePolygon,
    mapFinishedLoading,
    updateMapCenter,
    focusMapBoundsFromArray,
    panToLatlng,
};


// WEBPACK FOOTER //
// ./src/Store/Ducks/MapData/actions.js